import React, { useState, useEffect, useCallback, useRef } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

const DraftEditor = ({ handleDescription, description, clearEditor, assessment }) => {
    const [editorState, setEditorState] = useState(() => {
        const html = description || '';
        if (html.trim()) {
            try {
                const contentBlock = htmlToDraft(html);
                if (contentBlock && contentBlock.contentBlocks) {
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    return EditorState.createWithContent(contentState);
                }
            } catch (error) {
                console.warn('[DraftEditor] Error parsing HTML to Draft:', error);
            }
        }
        return EditorState.createEmpty();
    });
    
    const isTyping = useRef(false);
    const mountedRef = useRef(true);
    const initialDescriptionSet = useRef(false);

    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);

    // Update editor state from description prop
    useEffect(() => {
        // Allow first update even if typing, or if user is not actively typing
        if (isTyping.current && initialDescriptionSet.current) {
            return;
        }
        
        const html = description || '';
        if (html.trim()) {
            try {
                const contentBlock = htmlToDraft(html);
                if (contentBlock && contentBlock.contentBlocks) {
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    const currentContent = editorState.getCurrentContent().getPlainText();
                    const newContent = ContentState.createFromBlockArray(contentBlock.contentBlocks).getPlainText();
                    
                    // Update if content is different or it's the initial load
                    if (currentContent !== newContent || !initialDescriptionSet.current) {
                        setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(contentBlock.contentBlocks)));
                        initialDescriptionSet.current = true;
                    }
                }
            } catch (error) {
                console.warn('[DraftEditor] Error parsing HTML to Draft:', error);
            }
        } else if (clearEditor) {
            setEditorState(EditorState.createEmpty());
            initialDescriptionSet.current = false;
        }
    }, [description, clearEditor]);

    useEffect(() => {
        return () => {
            if (clearEditor) {
                setEditorState(EditorState.createEmpty());
            }
        };
    }, [clearEditor]);
    
    const onEditorStateChange = useCallback((newEditorState) => {
        isTyping.current = true;
        setEditorState(newEditorState);
        const html = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
        handleDescription(html);
        
        // Reset typing flag after a short delay
        setTimeout(() => {
            if (mountedRef.current) {
                isTyping.current = false;
            }
        }, 300);
    }, [handleDescription]);

    return (
        <div>
            <Editor
                editorState={editorState}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={onEditorStateChange}

            />
            {/* <textarea
                disabled
                value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
            /> */}
        </div>
    );
};

export default DraftEditor;
